module.exports = __webpack_public_path__ + "static/media/identification_card_back.61dfc465.svg";